import { Children, type ReactNode } from 'react';
import { Box, type SxProps, type Theme } from '@mui/material';
import { performTransportIconButtonSx } from '../preload-transition-shared';

/** Shared mobile touch-target styles for lower-control icon triples. */
export const performEqualSpreadIconButtonSx = {
  ...performTransportIconButtonSx,
  width: { xs: '100%', sm: undefined },
  height: { xs: 48, sm: undefined },
  borderRadius: { xs: 1, sm: undefined },
} as const;

const cellSx = {
  flex: { xs: '1 1 0', sm: '0 0 auto' },
  minWidth: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
} as const;

/**
 * On mobile, spreads each child equally across the available half-row
 * (edge → center divider). On sm+, keeps compact icon clustering.
 */
export function PerformEqualSpreadIconRow({ children, sx }: { children: ReactNode; sx?: SxProps<Theme> }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: { xs: '100%', sm: 'auto' },
        gap: { xs: 0, sm: 0.5 },
        minWidth: 0,
        ...sx,
      }}
    >
      {Children.map(children, (child, index) =>
        child == null ? null : (
          <Box key={index} sx={cellSx}>
            {child}
          </Box>
        ),
      )}
    </Box>
  );
}
